import {
  Grid,
  ThemeProvider,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import axios from "axios";
import institutes from "../../common/institutes";
import makeStyles from "@material-ui/styles/makeStyles";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import store from "store";
import theme from "../../assets/theme";
import CustomButtton from "../../components/CustomButtons/CustomButton";
import NetworkProgress from "../../mycomponents/NetworkProgress";
import {
  clearRank,
  clearResult,
  fetchRankAnalysis,
  fetchResultDetails,
} from "../../redux/actions/resultPageActions/actionCreators";
import BottomNav from "../BottomNav";
import CompareResult from "./CompareResult";
import ComparisonCard from "./ComparisonCards";
import MyAnswers from "./MyAnswers";
import NoResultMsg from "./NoResultMsg";
import ResultHeader from "./ResultHeader";
import { getTimeSpentPerSubjectAllTests } from "./TimeSpentMultipleTests";

const useStyles = makeStyles(() => ({
  content: {
    gap: "20px",
    [theme.breakpoints.up("md")]: {
      padding: "20px 20%",
    },
  },
  noKey: {
    marginTop: "10%",
  },
  pdf: {
    marginTop: "8%",
  },
  itemContainer: {
    width: "100%",
  },
}));
const Index = (props) => {
  const { location, match } = props;
  const exam = store.get("examObject") || {};
  const isMobile = useMediaQuery("(max-width:600px)");
  const query = new URLSearchParams(location.search);
  const [customQuestionsCount, setCustomQuestionCount] = useState(30);
  const user = store.get("user");
  const resultData = useSelector((state) => state.allResult);
  const rankAnalysis = useSelector((state) => state.rankAnalysis);
  const dispatch = useDispatch();
  const [
    account,
    studentIds,
    _id,
    admissionNo,
    level,
    pdf,
    isAdmin,
    isOffline,
    instituteId,
  ] = [
    query.get("accountType"),
    query.get("studentIds"),
    query.get("_id"),
    query.get("admissionNo"),
    query.get("level"),
    query.get("pdfLink"),
    query.get("isAdmin"),
    query.get("isOffline"),
    query.get("instituteId"),
  ];
  const institute_Id = instituteId || (user && user.institute);
  const userLevel = level || (user && user.level);
  const accountType = account || (user && user.accountType);
  const student_id = studentIds || (user && user.studentIds);
  const pdfLink = pdf || (exam && exam.pdfLink);
  const accessFeatures = {
    isAdmin: isAdmin,
    isOffline: isOffline,
  };
  const [data1, setData1] = useState({});
  const [loading, setLoading] = useState(true);
  const [timeSpentData, setTimeSpentData] = useState({});

  /* --- TIME CALCULATION --- */
  async function fetchTimeSpentData() {
    setLoading(true);
    console.log("@94-admissionNo=", admissionNo);
    const id = admissionNo || (store.get("user") && store.get("user").userId);
    console.log("@97-", id);

    const today = new Date();
    const endDate = new Date(today);
    endDate.setMonth(today.getMonth() - 3);
    const formatDate = (date) => date.toISOString().split("T")[0];
    const startDateFormatted = formatDate(today);
    const endDateFormatted = formatDate(endDate);
    const datesParam = JSON.stringify({
      startDate: endDateFormatted,
      endDate: startDateFormatted,
    });
    const tests = [match.params.test_name];
    const testsParam = JSON.stringify(tests);
    try {
      const response = await axios.post(
        `https://${
          institutes[institute_Id]
        }/api/analysis/getStudentQuestionBehaviours/${id}?dates=${encodeURIComponent(
          datesParam
        )}&instituteId=${encodeURIComponent(
          institute_Id
        )}&tests=${encodeURIComponent(testsParam)}`
      );
      setData1(response.data);
      setLoading(false);
      return response.data;
    } catch (error) {
      setLoading(false);
      throw error;
    }
  }

  useEffect(() => {
    setCustomQuestionCount(resultData.dataResult.length);
  }, [resultData, rankAnalysis]);
  useEffect(() => {
    const body = {
      student_id:
        accountType && accountType === "parent"
          ? student_id
          : _id || store.get("user")._id,
      test_name: match.params.test_name,
      code: query.get("code"),
      isOffline: isOffline === "true",
    };
    try {
      dispatch(fetchResultDetails(body));
      dispatch(fetchRankAnalysis(body));
    } catch (error) {
      console.log(error);
    }
    return () => {
      dispatch(clearResult());
      dispatch(clearRank());
    };
  }, []);

  useEffect(() => {
    fetchTimeSpentData();
  }, []);

  useEffect(() => {
    if (data1 && data1.payload) {
      const data2 = getTimeSpentPerSubjectAllTests(data1.payload);
      if (data2 && data2[match.params.test_name]) {
        setTimeSpentData(data2[match.params.test_name]);
      } else {
        setTimeSpentData({});
      }
    }
  }, [data1]);

  const classes = useStyles();

  if (rankAnalysis.error) {
    return <NoResultMsg header />;
  }
  if (userLevel == "19189210")
    return (
      <NoResultMsg
        header
        text="Your test got submitted successfully, Results will be announced after two day."
      />
    );

  if (
    [
      "211210",
      "2119710",
      "X0210767",
      "X0210766",
      "X0210765",
      "X0210764",
    ].includes(`${userLevel}`) &&
    accountType !== "parent"
  )
    return <NoResultMsg header />;

  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        {(!loading || !rankAnalysis.isLoading) && resultData.keyAvailable && (
          <div style={{ padding: "10px" }}>
            {/* header start */}
            {isAdmin ? null : (
              <ResultHeader testDisplayName={query.get("test")} />
            )}
            {/* header end */}
            {/* content start */}
            {navigator.userAgent.includes("Android") &&
              window.Android &&
              pdfLink && (
                <Grid container className={classes.pdf}>
                  <Grid item>
                    &emsp;
                    <CustomButtton
                      label="View PDF"
                      handleGetClick={() => window.Android.showPDF(pdfLink)}
                    />
                  </Grid>
                </Grid>
              )}

            {isMobile ? (
              <Grid container className={classes.content}>
                {/* rank ,grade and accuracy cards */}
                <Grid item className={classes.itemContainer}>
                  <ComparisonCard
                    customQuestionsCount={customQuestionsCount}
                    paper={query.get("paper")}
                    test_type={query.get("type")}
                    test_name={match.params.test_name}
                    resultData={resultData}
                    timeSpentData={timeSpentData}
                  />
                </Grid>
                {/* if showResult exist then only show answer and statistics section  */}
                {rankAnalysis.data.showResult === false || rankAnalysis.data.showResult === "false" ? null : (
                  <React.Fragment>
                    {/* my answers and my statistics section*/}
                    <Grid item className={classes.itemContainer}>
                      <MyAnswers accessFeatures={accessFeatures} />
                    </Grid>
                    {/* comparison of results with other students */}
                    {/* <Grid item className={classes.itemContainer}>
                    <CompareResult
                      test_name={match.params.test_name}
                      id={_id || store.get("user")._id}
                    />
                  </Grid> */}
                  </React.Fragment>
                )}
              </Grid>
            ) : (
              <React.Fragment>
                <Grid item className={classes.itemContainer}>
                  <ComparisonCard
                    customQuestionsCount={customQuestionsCount}
                    paper={query.get("paper")}
                    test_type={query.get("type")}
                    test_name={match.params.test_name}
                    resultData={resultData}
                    instituteId={instituteId}
                    timeSpentData={timeSpentData}
                  />
                </Grid>
                {rankAnalysis.data.showResult === false || rankAnalysis.data.showResult === "false" ? null : (
                  <React.Fragment>
                    <Grid item className={classes.itemContainer}>
                      <MyAnswers accessFeatures={accessFeatures} />
                    </Grid>
                  </React.Fragment>
                )}
              </React.Fragment>
            )}

            {/* content ends */}
          </div>
        )}
        {!resultData.isLoading && !resultData.keyAvailable && (
          <Grid container direction="row" justify="center" alignItems="center">
            <Typography component="h1" variant="h3" className={classes.noKey}>
              {userLevel == "2119611"
                ? "Thank you for choosing B-SAT. Results will be announced soon."
                : "Key is not uploaded to evaluate"}
            </Typography>
          </Grid>
        )}
        {(loading || resultData.isLoading) && (
          <NetworkProgress> </NetworkProgress>
        )}
      </ThemeProvider>
      {isAdmin ? null : <BottomNav />}
    </React.Fragment>
  );
};

export default Index;
